import React, { Component } from 'react';
import { ProSidebar, Menu, MenuItem, SubMenu, SidebarHeader, SidebarFooter, SidebarContent } from 'react-pro-sidebar';
import "react-pro-sidebar/dist/css/styles.css";
import './Sidebar.css';
import iconI from './images/tic-ms-i-icon-white.png';
import iconS from './images/tic-ms-s-icon-white.png';
import iconM from './images/tic-ms-m-icon-white.png';
import iconN from './images/tic-ms-n-icon-white.png';
import iconT from './images/tic-ms-t-icon-white.png';
import iconC from './images/tic-ms-c-icon-white.png';

import iconCompany from './images/tic-ms-company-icon.png';
import iconInstrument from './images/tic-ms-instruments-icon.png';
import iconCerts from './images/tic-ms-certs-icon.png';
import iconManage from './images/tic-ms-manage-icon.png';
import iconSchedule from './images/tic-ms-schedule-icon.png';
import iconInquire from './images/tic-ms-inquire-icon.png';
import iconEndUsers from './images/tic-ms-end-users-icon.png';
import iconCustomer from './images/tic-ms-customer-icon.png';


import { FiArrowLeftCircle, FiArrowRightCircle } from 'react-icons/fi';
import { useHistory } from 'react-router-dom';
import AuthFunctions from '../services/AuthService';

class Sidebar extends Component {
    static displayName = Sidebar.name;
   
    constructor(props) {
        super(props);

        this.state = {
            collapsed: true,
            toggled: true,
            authenticated: false,
        };

        this.menuIconClick = this.menuIconClick.bind(this);
        this.menuItemClick = this.menuItemClick.bind(this);
        this.checkAuthenticated();
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        this.setState({ authenticated: isAuthenticated });
    }

    menuIconClick(event) {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    menuItemClick(options) {
        this.props.history.push(options);
    }

    render() {
        return (
            <div id="sidebar" hidden={!this.state.authenticated}>
                <ProSidebar
                    collapsed={this.state.collapsed}
                    toggled={true}
                    breakPoint="md"
                    width="500px"
                >
                    <SidebarHeader>
                        <div className="closemenu" onClick={this.menuIconClick}>
                        {this.state.collapsed ? (
                            <FiArrowRightCircle/>
                        ) : (
                            <FiArrowLeftCircle/>
                        )}
                        </div>
                    </SidebarHeader>                    
                    <SidebarContent style={{height: '100%'}}>
                        <Menu iconShape="circle" style={{ height: '100%' }}>
                            <SubMenu title={'The Account'} icon={<img src={iconCompany} className="iconImage" />} className="streetSign">
                                <MenuItem className='pro-inner-item-header'>The Account</MenuItem>
                                <MenuItem onClick={() => this.menuItemClick({ pathname: '/accounts/details', state: {} })}>Account Information</MenuItem>
                                <MenuItem onClick={() => this.menuItemClick({ pathname: '/accounts/invoices', state: {} })}>Invoices</MenuItem>
                            </SubMenu>
                            <SubMenu title={'Instruments / Quotes / Packing List'} icon={<img src={iconInstrument} className="iconImage" />} className="streetSign">
                                <MenuItem className='pro-inner-item-header'>Instruments / Quotes / Packing List</MenuItem>
                                <MenuItem onClick={() => this.menuItemClick({ pathname: '/instrument/NewPackingList', state: {} })}>New Instruments</MenuItem>
                                <MenuItem onClick={() => this.menuItemClick({ pathname: '/instrument/ExistingPackingList', state: {} })}>Existing Instruments</MenuItem>
                            </SubMenu>
                            <SubMenu title={'Cals & Certs'} icon={<img src={iconCerts} className="iconImage" />} className="streetSign">
                                <MenuItem className='pro-inner-item-header'>Cals &amp; Certs</MenuItem>
                                <MenuItem onClick={() => this.menuItemClick({ pathname: '/calsNCerts/CalsNCerts', state: {} })}>Cals &amp; Certs</MenuItem>
                            </SubMenu>
                            <SubMenu title={'Manage Assets'} icon={<img src={iconManage} className="iconImage" />} className="streetSign">
                                <MenuItem className='pro-inner-item-header'>Manage Assets</MenuItem>
                                <MenuItem onClick={() => this.menuItemClick({ pathname: '/manageAssets/ManageAssets', state: {} })}>Manage TICMS Calibrated Assets</MenuItem>
                                <MenuItem onClick={() => this.menuItemClick({ pathname: '/manageAssets/CompanyAssets', state: {} })}>Add Company Managed Assets</MenuItem>
                            </SubMenu>
                            <SubMenu title={'Schedule On-Site'} icon={<img src={iconSchedule} className="iconImage" />} className="streetSign">
                                <MenuItem className='pro-inner-item-header'>Schedule On-Site</MenuItem>
                                <MenuItem onClick={() => this.menuItemClick({ pathname: '/schedule/onsite', state: {} })}>Schedule On-Site</MenuItem>
                            </SubMenu>
                            <SubMenu title={'Inquire Order Status'} icon={<img src={iconInquire} className="iconImage" />} className="streetSign">
                                <MenuItem className='pro-inner-item-header'>Inquire Order Status</MenuItem>
                                <MenuItem onClick={() => this.menuItemClick({ pathname: '/inquire/order', state: {} })}>Inquire Order Status</MenuItem>
                            </SubMenu>
                            <SubMenu title={'End Users'} icon={<img src={iconEndUsers} className="iconImage" />} className="streetSign">
                                <MenuItem className='pro-inner-item-header'>End Users</MenuItem>
                                <MenuItem onClick={() => this.menuItemClick({ pathname: '/admin/users', state: {} })}>User Search</MenuItem>
                                <MenuItem onClick={() => this.menuItemClick({ pathname: '/admin/users/details', state: { existingUser: false } })}>User Setup &amp; Detail</MenuItem>
                            </SubMenu>
                            <SubMenu title={'Customer Service'} icon={<img src={iconCustomer} className="iconImage" />} className="streetSign">
                                <MenuItem className='pro-inner-item-header'>Customer Service</MenuItem>
                                <MenuItem onClick={() => this.menuItemClick({ pathname: '/customerService/CustomerService', state: {} })}>Customer Service</MenuItem>
                            </SubMenu>
                        </Menu>
                    </SidebarContent>
                </ProSidebar>
            </div>
        )
    }
}

export default () => {
    const history = useHistory();
    return (
        <Sidebar history={history} />
    )    
}